import { lazyNamed } from 'src/utils/lazyNamed';

export const Advertisers = {
  AdvertisersList: lazyNamed(() => import('./containers/AdvertisersList'), 'AdvertisersList'),
  AdvertiserOverview: lazyNamed(() => import('./containers/AdvertiserOverview'), 'AdvertiserOverview'),
  ConversionTrackerForm: lazyNamed(() => import('./containers/ConversionTrackerForm'), 'ConversionTrackerForm'),
};
